<template>
  <b-button class="print-screen" @click="printScreen" title="print screen">
    <picture>
      <img src="@/assets/icons/printFriendly.svg" alt="logo" />
    </picture>
  </b-button>
</template>
<script>
export default {
  name: 'ButtonPrintScreen',
  methods: {
    printScreen() {
      window.print();
    },
  },
};
</script>
<style lang="scss">
.print-screen {
  line-height: 0;
  color: var(--color-main);
  background-color: rgba(255, 255, 255, 0.382);
  box-shadow: 1px 1px 5px -1px #777171cc;
  border: none;
  position: fixed;
  z-index: 100;
  bottom: 20px;
  right: 40px;

  @media (max-width: 576px) {
    right: 30px;
  }

  picture {
    display: block;
    width: 30px;
    img {
      object-fit: contain;
      width: 100%;
    }
  }
}

@media print {
  /* Hide scrollbars */
  * {
    overflow: hidden !important;
    --webkit-print-color-adjust: exact;
    --moz-print-color-adjust: exact;
    --ms-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .print-screen {
    display: none;
  }

  a {
    text-decoration: none !important;
  }
}
</style>
